module.exports = __webpack_public_path__ + "static/img/status-active.998f9f18.png";